import { createRoute } from '@tanstack/react-router';
import { format, subMonths } from 'date-fns';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodOptionalDate, zodOptionalId, zodOptionalIdArray } from 'routes/routeUtils';
import { z } from 'zod';

export const labTradesDashboardRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/dashboard',
  validateSearch: z.object({
    tradeIds: zodOptionalIdArray,
    search: z.string().optional(),
    transmittedAtRange: z
      .object({ from: zodOptionalDate, to: zodOptionalDate })
      .default({
        from: format(subMonths(Date.now(), 3), 'yyyy-MM-dd'),
      })
      .optional(),
    groupId: zodOptionalId,
    pharmacyId: zodOptionalId,
    regionalDirectorIds: zodOptionalIdArray,
  }),
}).lazy(() =>
  import('pages/lab/Trades/Dashboard/LabTradesDashboardPage/LabTradesDashboardPage').then(
    (d) => d.Route
  )
);
